import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsCategoryDemandPayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND;
    id: string;
    attributes: {
      data: Array<{
        category_id: string;
        category_name: string;
        projects_without_tasks: number;
        partially_scoped_projects: number;
        fully_scoped_projects: number;
        total_project_count: number;
        total_demand_hours: number;
      }>;
    };
  };
}

export const parseProjectsCategoryDemandPayload = (
  payload: BaseInsightPayload
): ProjectsCategoryDemandPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      category_id: string;
      category_name: string;
      projects_without_tasks: number;
      partially_scoped_projects: number;
      fully_scoped_projects: number;
      total_project_count: number;
      total_demand_hours: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
